import { clsx } from "@trydig/ui";
import type { ComponentProps, PropsWithChildren } from "react";
import InfoSvg from "~/public/icons/16px/Info.svg";
import styles from "./Callout.module.css";

interface CalloutProps extends ComponentProps<"aside">, PropsWithChildren {
	variant: "info" | "error";
}

export const Callout = ({ className, variant, children, ...rest }: CalloutProps) => {
	return (
		<aside className={clsx(styles.callout, styles[variant], className)} {...rest}>
			<span className={styles.icon}>
				<InfoSvg />
			</span>
			{children}
		</aside>
	);
};
